<div class="flex window">
    <div class="flex tall column seg-blue">
        <div class="flex up-bar">
            <div class="tr-title">
                Medical Trust
            </div>

            <img src={{MileleLogoPath}} class="milele-logo-alt" alt="logo" (click)="navHome()" />
            
            <!-- <img src={{logoPath}} class="logo web" alt="logo" /> -->
        </div>

        <div class="flex go-back" (click)="goBack()">
            <mat-icon fontIcon="arrow_back" aria-hidden="false" aria-label="Back button"></mat-icon>
            <span style="margin-left: 10px;">Go Back</span>
        </div>
        
        <div class="flex seg-content in-row">
            <div class="flex column seg-text">
                <span class="wanna">
                    I want to
                </span>
                <span class="ensure-text">
                    "Stop losing my unutilized medical insurance premiums every year and build a lasting health reserve."
                </span>

                <div class="flex ensure-p block" (click)="toggleDescription(1)" *ngIf="!toggleText1">
                    Read More
                    <span class="chevron-down"></span>
                </div>

                <div class="flex" style="flex-direction: row-reverse;" (click)="toggleDescription(1)" *ngIf="toggleText1">
                    <div class="flex less-button">
                        <span class="chevron-up chev-blue"></span>
                        <span style="margin-left: 10px;">Read Less</span>
                    </div>
                </div>
                <span class="ensure-p" *ngIf="toggleText1">
                    Traditional medical insurance operates on a "sunk-cost" model, where any money you don't use by the end 
                    of the year is lost. You can now build a health reserve at your own pace without rigid insurance penalties.<br><br>
                    By setting up a Medical Trust account, 100% of your unutilized capital rolls over to the next year and earns 
                    compound interest. You can fund this trust incrementally through regular monthly deposits. The fund is held 
                    in a secure investment kitty, growing over time, while you and your family access comprehensive Outpatient 
                    and Inpatient care via our digital wallet on the M-TIBA network.
                </span>
                <div class="flex inf-buttons">
                    <div class="flex white button" style="margin-right: 5%;" (click)="toggleBookPopupClose(true)"> {{ bookCall }} </div>
                    <div class="flex white-outline button" (click)="navMedicalTrust()"> {{ startHere }} </div>
                    
                </div>
            </div>
            <div class="flex column seg-image">
                <div class="flex ch-holder" >
                    <img src={{childrenPath}} class="children" alt="children" />
                </div>
            </div>
        </div>
    </div>

    <div class="flex short seg-gray in-row">
        <div class="flex column seg-image">
            <div class="flex ch-holder" >
                <img src={{bossGalPath}} class="children" alt="children" />
            </div>
        </div>

        <div class="flex column seg-text">
            <span class="wanna">
                I want to
            </span>
            <span class="ensure-text">
                "Establish a perpetual, self-funding health cover for my family that lasts for generations."
            </span>

            <div class="flex ensure-p block border-blue" (click)="toggleDescription(2)" *ngIf="!toggleText2">
                Read More
                <span class="chevron-down chev-blue"></span>
            </div>

            <div class="flex" style="flex-direction: row-reverse;" (click)="toggleDescription(2)" *ngIf="toggleText2">
                <div class="flex less-button">
                    <span class="chevron-up chev-blue"></span>
                    <span style="margin-left: 10px;">Read Less</span>
                </div>
            </div>
            <span class="ensure-p" *ngIf="toggleText2">
              High-Net-Worth individuals and families often seek absolute health security without 
              the burden of continuous annual premium payments.<br><br>
              You can deploy a lump-sum deposit to create a Medical Trust Endowment. The structure 
              of this trust ensures that your principal investment remains completely untouched. 
              Instead, the annual interest yield generated by ICEA LION Trust fully funds your family's 
              premium domestic or international medical cover. Because the premiums are serviced entirely 
              by interest, the capital principal is seamlessly passed down to the next generation, 
              achieving true multi-generational wealth and health transfer.
            </span>
            <div class="flex inf-buttons">
                <div class="flex blue button" style="margin-right: 5%;" (click)="toggleBookPopupClose(true)"> {{ bookCall }} </div>
                <div class="flex blue-outline button" (click)="navMedicalTrust()"> {{ startHere }} </div>
            </div>
        </div>
    </div>

    <div class="flex tall row seg-blue in-row">
        <div class="flex column seg-text" style="margin-bottom: 20px; margin-top: 10px;">
            <span class="wanna">
                I want to
            </span>
            <span class="ensure-text">
                "Secure specialized, dignified healthcare and support for my aging parents"
            </span>

            <div class="flex ensure-p block" (click)="toggleDescription(3)" *ngIf="!toggleText3">
                Read More
                <span class="chevron-down"></span>
            </div>

            <div class="flex" style="flex-direction: row-reverse;" (click)="toggleDescription(3)" *ngIf="toggleText3">
                <div class="flex less-button">
                    <span class="chevron-up chev-blue"></span>
                    <span style="margin-left: 10px;">Read Less</span>
                </div>
            </div>
            <span class="ensure-p" *ngIf="toggleText3">
              As parents age, they often require specialized care that falls outside the boundaries 
              of standard acute medical insurance, creating significant financial and emotional strain on families.<br><br>
              You can set up a Medical Trust with a dedicated <strong>Silver Care</strong> ecosystem. This specific configuration ring-fences 
              funds and unlocks access to specialized partner networks for home nursing, cognitive therapy, specialized 
              senior care, and palliative support. Furthermore, our Health Concierge desk will assist in navigating and 
              coordinating these complex care arrangements, ensuring your parents receive the best possible support in their old age
            </span>
            <div class="flex inf-buttons">
                <div class="flex white button" style="margin-right: 5%;" (click)="toggleBookPopupClose(true)"> {{ bookCall }} </div>
                <div class="flex white-outline button" (click)="navMedicalTrust()"> {{ startHere }} </div>
                
            </div>
        </div>

        <div class="flex column seg-image">
            <div class="flex ch-holder" >
                <img src={{medicalPath}} class="medical" alt="medical" />
            </div>
        </div>
    </div>

    <div class="flex short row seg-gray in-row">
        <div class="flex column seg-image">
            <div class="flex ch-holder" >
                <img src={{charityPath}} class="children" alt="children" />
            </div>
        </div>

        <div class="flex column seg-text" style="margin-bottom: 50px; margin-top: 50px;">
            <span class="wanna">
                I want to
            </span>
            <span class="ensure-text">
                "Transition my company to a transparent, self-funded medical scheme for my employees"
            </span>

            <div class="flex ensure-p block border-blue" (click)="toggleDescription(4)" *ngIf="!toggleText4">
                Read More
                <span class="chevron-down chev-blue"></span>
            </div>

            <div class="flex" style="flex-direction: row-reverse;" (click)="toggleDescription(4)" *ngIf="toggleText4">
                <div class="flex less-button">
                    <span class="chevron-up chev-blue"></span>
                    <span style="margin-left: 10px;">Read Less</span>
                </div>
            </div>
            <span class="ensure-p" *ngIf="toggleText4">
              Corporate employers, HR Managers, and Finance Directors are continually battling high annual insurance 
              inflation and lack of transparency in traditional corporate medical schemes.<br><br>
              You can establish a Corporate Medical Trust as a self-funded health alternative. By depositing your staff 
              health funds into the trust, your business earns interest on the unutilized reserves. The platform seamlessly 
              integrates with the M-TIBA network to adjudicate claims in real-time, automatically provision digital health 
              cards to employees, and restrict spending to specific tiers using smart contracts—giving you total control and 
              visibility over your employee health benefits.
            </span>
            <div class="flex inf-buttons">
                <div class="flex blue button" style="margin-right: 5%;" (click)="toggleBookPopupClose(true)"> {{ bookCall }} </div>
                <div class="flex blue-outline button" (click)="navMedicalTrust()"> {{ startHere }} </div>
            </div>
        </div>
    </div>

    <div class="flex short row seg-blue in-row">
        <div class="flex column seg-text">
            <span class="wanna">
                I want to
            </span>
            <span class="ensure-text">
                "Prioritize proactive, preventative health and holistic wellness rather than just reacting to illness"
            </span>

            <div class="flex ensure-p block" (click)="toggleDescription(5)" *ngIf="!toggleText5">
                Read More
                <span class="chevron-down"></span>
            </div>

            <div class="flex" style="flex-direction: row-reverse;" (click)="toggleDescription(5)" *ngIf="toggleText5">
                <div class="flex less-button">
                    <span class="chevron-up chev-blue"></span>
                    <span style="margin-left: 10px;">Read Less</span>
                </div>
            </div>
            <span class="ensure-p" *ngIf="toggleText5">
              Modern health security is about more than just paying for doctor visits when you are sick; it is about investing 
              in longevity and quality of life.<br><br>
              The Medical Trust allows you to customize your benefit ecosystem beyond basic clinical care. You can activate specific 
              <strong>Preventative Care</strong> and <strong>Wellness & Lifestyle</strong> modules. This ensures your trust funds are deliberately allocated for annual 
              check-ups, early screenings, nutritional counselling, and wellness retreats. Through our smart-contract integration, these 
              funds are reserved specifically for proactive health partners, putting your family's long-term wellness first.

            </span>
            <div class="flex inf-buttons">
                <div class="flex white button" style="margin-right: 5%;" (click)="toggleBookPopupClose(true)"> {{ bookCall }} </div>
                <div class="flex white-outline button" (click)="navMedicalTrust()"> {{ startHere }} </div>
            </div>
        </div>

        <div class="flex column seg-image">
            <div class="flex ch-holder" >
                <img src={{galPath}} class="gal" alt="gal" />
            </div>
        </div>
    </div>

    <div class="flex seg-gray last">
        {{ powererdBy }}
    </div>
</div>

<app-book-call *ngIf="showBookCall" (close)="toggleBookPopupClose(false)" ></app-book-call>
